import { createSlice, current } from "@reduxjs/toolkit";
import * as Act from "./actions";
const initialState = {
  loading: false,
  PAYMENTSLISTDATA: [],
  totalCount: 0,
};
const slice = createSlice({
  name: "PAYMENTSLISTDATA",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(Act.TokenRevenueList.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.TokenRevenueList.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      PAYMENTSLISTDATA: payload || [],
      totalCount: payload?.totalcount || 0,
    }));
    builder.addCase(Act.TokenRevenueList.rejected, (state, { payload }) => ({
      ...state,
      loading: false,
      error: payload || "Unknown error",
      PAYMENTSLISTDATA: [],
      totalCount: 0,
    }));
    builder.addCase(Act.ImagesToken.pending, (state, action) => ({
        ...state,
        loading: true,
      }));
      builder.addCase(Act.ImagesToken.fulfilled, (state, { payload }) => ({
        ...state,
        loading: false,
        PAYMENTSLISTDATA: payload || [],
        totalCount: payload?.totalcount || 0,
      }));
      builder.addCase(Act.ImagesToken.rejected, (state, { payload }) => ({
        ...state,
        loading: false,
        error: payload || "Unknown error",
        PAYMENTSLISTDATA: [],
        totalCount: 0,
      }));
  },
});

export default slice;
